export enum InvestigationAttestationStatus {
	Pending = 1,
	Attested = 2,
	AttestedWithReservation = 3,
	Automatic = 4,
}
